import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery, Shadow, Transition } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: ${Transition.OPACITY_EASE};
  margin: 0 auto 150px auto;
  max-width: 1200px;
  position: relative;

  ${MediaQuery.XL_AND_DOWN} {
    margin: 0px 45px 100px 45px;
  }
`;

export const Title = styled.h2`
  ${Typography.XXXXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  text-align: center;
`;

export const Testimonial = styled.div`
  display: flex;
  width: 100%;
  margin-top: 50px;
  justify-content: center;
  transition: ${Transition.ALL_EASE};

  ${MediaQuery.L_AND_DOWN} {
    flex-direction: column;
    margin-top: 25px;
  }
`;

export const IllustrationContainer = styled.div`
  position: relative;

  ${MediaQuery.L_AND_DOWN} {
    display: none;
  }
`;

export const AuthorPicture = styled.div`
  & > div {
    max-width: 277px;
    max-height: 277px;
  }
`;

export const LogoWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;

  & > div {
    max-width: 84px;
    max-height: 84px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  align-self: center;
  flex-direction: column;
  padding-left: 50px;
  max-width: 570px;

  ${MediaQuery.L_AND_DOWN} {
    padding-left: 0px;
  }
`;

export const Quote = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
  margin-bottom: 30px;
`;

export const Author = styled.p`
  ${Typography.M_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin-bottom: 10px;
`;

export const Job = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
`;

export const IllustrationWrapper = styled.div`
  position: absolute;
  width: 450px;
  height: 350px;
  top: 0px;
  right: 0px;
  z-index: -1;

  ${MediaQuery.S_AND_DOWN} {
    width: 300px;
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: space-between;
  top: ${({ hasTitle }) => (hasTitle ? '50%' : '30%')};
  margin-top: 25px;

  ${MediaQuery.L_AND_DOWN} {
    justify-content: center;
    position: inherit;
  }
`;

export const LinearGradient = styled.svg`
  height: 0px !important;
  width: 0px !important;
`;

export const CustomIcon = styled.button`
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: ${Color.WHITE};
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid transparent;
  box-shadow: ${Shadow.BLUE_BOX};
  transition: ${Transition.ALL_EASE};

  &:hover {
    background-color: ${Color.WHISPER};
  }

  svg {
    height: 20px;
    width: 20px;
    fill: url(#custom-gradient);
  }

  ${MediaQuery.L_AND_DOWN} {
    margin: 0 20px;

    svg {
      fill: ${Color.BLUE_RIBBON};
    }
  }
`;
